// import { api, client } from "@/client";
import { client } from "@/client";
import { folder } from "jszip";
import { defineStore, acceptHMRUpdate } from "pinia";

export const useFolderStructureStore = defineStore("folderstruct", {
  state: () => ({
    loading: false,
    totalFile: 0,
    selectedTransferId: "",
    convertedStructure: [],
    initStructure: [],
    rawStructure: [{}],
  }),
  getters: {},
  actions: {
    async fetchFolderData(id: any) {
      this.$reset();
      this.loading = true;
      client.content
        .contentsListTransferFiles({ id: id })
        .then((payload) => {
          this.rawStructure = payload;
          this.sortFolderData(this.rawStructure);
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    sortFolderData(folderStructure) {
      let result: any = [];
      let level = { result };
      let fullPath = "";
      for (let index = 0; index < folderStructure.length; index++) {
        fullPath = folderStructure[index].path;

        //ASI change API structure
      // for (let index = 1; index < folderStructure.length; index++) {
      //   fullPath =
      //     folderStructure[index].path + "/" + folderStructure[index].name;
        if (fullPath.substring(0, 1) === "/") {
          fullPath = fullPath.substring(1);
        }
        fullPath.split("/").reduce((accumulator: any, currentValue: string) => {
          if (!accumulator[currentValue]) {
            if (currentValue.includes(".")) {
              this.totalFile++;
            }
            accumulator[currentValue] = { result: [] };
            accumulator.result.push({
              id: "customization-class-rootNode",
              label: currentValue,
              children: accumulator[currentValue].result,
              style: folderStructure[index].type,
            });
          }
          return accumulator[currentValue];
        }, level);
        this.convertedStructure = result;
      }
    },

    reject() {},
    reset() {
      this.convertedStructure = [];
      this.rawStructure = [];
    },
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(
    acceptHMRUpdate(useFolderStructureStore, import.meta.hot)
  );
}
